import 'regenerator-runtime/runtime';

// Polyfills
import 'array-flat-polyfill'; // array.flat method not supported in browsers like Edge

import React from 'react';
import ReactDOM from 'react-dom';

if (process.env.NODE_ENV !== 'production') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  // whyDidYouRender(React, {
  //     trackAllPureComponents: true,
  // });
}

import AppContainer from './containers/AppContainer';
import Stack from '../junction/layout/stack/Stack';

// React entry point
const MOUNT_NODE = document.getElementById('root');

// Lazy load the routes
import('./routes').then((routes: any) => {
  let render = () => {
    ReactDOM.render(
      <AppContainer>
        <routes.default key='root' />
      </AppContainer>,
      MOUNT_NODE,
    );
  };
  render();
});
